export const STUDY_TITLES = {
	backup: 'T_RESULTS_BACKUP',
	selectivity: 'T_RESULTS_SELECTIVITY',
};
